/**
 * Returns `document.referrer` reduced to `origin + pathname`. Strips query and
 * fragment so sensitive same-origin params (e.g. `/set-password?token=…`) do
 * not flow into Sentry tags or other telemetry sinks. Returns `"(none)"` if no
 * referrer is set, `"(unparseable)"` if the referrer is not a valid URL.
 */
export function getSanitizedReferrer(): string {
	if (typeof document === "undefined" || !document.referrer) {
		return "(none)";
	}

	try {
		const url = new URL(document.referrer);
		return `${url.origin}${url.pathname}`;
	} catch {
		return "(unparseable)";
	}
}
